/* H26 · Lab — o "57%" conta junto com o anel.
   O arco anima por CSS (stroke-dashoffset: --arc → 0 quando o reveal da base põe .is-in no card).
   Aqui o número é DERIVADO do offset real do arco a cada frame (n = pct × (1 − offset/arc)), então
   número e arco não têm como dessincronizar em nenhum navegador. Sem JS: o HTML já traz o valor final. */
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('.h26-lab__stat[data-h26-reveal]').forEach(function (card) {
      if (card.__h26lab) return; card.__h26lab = true;
      var arc = card.querySelector('.h26-lab__arc');
      var num = card.querySelector('.h26-lab__pct-num');
      if (!arc || !num) return;
      var pct = parseInt(card.querySelector('.h26-lab__pct').style.getPropertyValue('--h26-lab-pct'), 10) || 0;
      var total = parseFloat(arc.style.getPropertyValue('--arc')) || 0;
      if (!total) return;
      var raf = 0;
      function paint() {
        var off = parseFloat(getComputedStyle(arc).strokeDashoffset) || 0;
        num.textContent = Math.round(pct * (1 - Math.min(1, Math.max(0, off / total)))) + '%';
      }
      function loop(until) {
        paint();
        if (performance.now() < until) raf = requestAnimationFrame(function () { loop(until); });
      }
      function start() { cancelAnimationFrame(raf); loop(performance.now() + 1300); } // 150ms delay + 900ms + folga
      // já revelado (estava na tela ao carregar) → valor final; senão começa em 0 e conta no reveal
      if (card.classList.contains('is-in')) { num.textContent = pct + '%'; return; }
      // começa em 0 explícito (não pelo offset: seção pulada por content-visibility pode reportar o
      // offset errado no WebKit e mostrar o valor final por um instante antes de contar)
      num.textContent = '0%';
      new MutationObserver(function () { if (card.classList.contains('is-in')) start(); })
        .observe(card, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
